import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

export default createAPIRequestReducer(ActionTypes.BASEDATA_TECHNOLOGY_DETAILS_LOAD)
